import React from 'react'
import './warning.css'
import gifWarningDarkMode from './img/gifWarningDarkMode.2gif.gif'
import { BsFillSunFill } from 'react-icons/bs';

export default function WarningDarkModePtBr({darkMode, setDarkMode}) {

    if (darkMode === true) {
        document.body.classList.add('no-scroll');
    } else {
        document.body.classList.remove('no-scroll');
    }

    return (
        <>
        {darkMode ? (
            <div className="container_popup_warning">
            <div className="popup_warning">
            <span className='popup_warning_subtitle'>Dark-Mode</span>
            <h2 className='popup_warning_title'>Aviso</h2>
                <BsFillSunFill onClick={() => {
                    setDarkMode(!darkMode)}}
                    className='warning_back_to_light_mode' 
                    alt='close pop up warning'/>
                <div className="warning_content">
                    <p>Poxa, desculpe ): mas o design do dark mode ainda não foi concluído...</p>
                    <img className='WarningDarkModeGIF' src={gifWarningDarkMode} alt="Cute Anime GIF" />
                    <p id='warning_content_explain'>Optei por implementar um switch entre o modo claro e escuro e manter a transição e animação ativas, mesmo que ainda não estejam prontas, porque quero que os usuários vejam que o processo de adaptação de um dark mode à página é um plano em andamento. Espero que você aproveite as outras funcionalidades e explore as seções do site para me conhecer melhor (: Desde já, agradeço.</p>
                    <span>Observação: Para retornar ao light mode, clique no ícone do sol no canto superior direito.</span>
                </div>
            </div>
        </div>
        ): ''}  
    </>
    )
}
